import {FeedbackBadge, ReportAiDisclosure} from '../ai/DisclosureControls';
import React from 'react';
import {Card} from '@betareader/design-system';
import moment from 'moment';
import i18n from '../../utils/i18n/i18n';
import Avatar from '../avatar/avatar';
import RatingStars from './RatingStars';

const ReviewItem = (
  {
    reviewData
  }
) => (
  <Card key={reviewData._id} style={{padding: '1rem'}}>
      {
        reviewData.user && (
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Avatar name={reviewData.user.displayName} />
                <span style={{ marginLeft: '1em' }}>
                  {reviewData.user.displayName}
                </span>
              </div>
              <span style={{ fontSize: '0.8em', justifyContent: 'flex-end' }}>
                {moment(reviewData.updatedAt).format('LLL')}
              </span>
            </div>
          </React.Fragment>
        )
      }
      <div>
        <FeedbackBadge origin={reviewData.aiOrigin} /> <ReportAiDisclosure bookId={reviewData.book?._id || reviewData.book} feedbackId={reviewData._id} />
              <table className='plain-table'>
                <tbody>
                  {reviewData.aiOrigin !== 'generated' && <><tr>
                    <th scope='row'>
                      {i18n.t('OverallRating')}
                      :
                    </th>
                    <td>
                      <RatingStars label={i18n.t('OverallRating')} value={reviewData.overAllRating} />
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>
                      {i18n.t('PlotRating')}
                      :
                    </th>
                    <td>
                      <RatingStars label={i18n.t('PlotRating')} value={reviewData.plotRating} />
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>
                      {i18n.t('GrammarRating')}
                      :
                    </th>
                    <td>
                      <RatingStars label={i18n.t('GrammarRating')} value={reviewData.grammarRating} />
                    </td>
                  </tr>
                  </>}<tr>
                    <td colSpan={2}>
                      <div style={{ whiteSpace: 'pre-wrap' }}>
                        {reviewData.text}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
      </div>
  </Card>
);

export default (ReviewItem);
